import { Timestamp as PBTimestamp } from "gen/google/protobuf/timestamp_pb"
import { Format, Timestamp } from "shared-ts/classes/timestamp"

import { data } from "./data"
import { TypedAccessor } from "./types"
import { TableCellWidth } from "../TableCell"
import { DataColumn } from "../useTable/types"

type TimestampAccessorFn<T> = TypedAccessor<T, PBTimestamp | undefined>
interface TimestampColumn<T>
  extends Omit<DataColumn<T>, "type" | "renderCell" | "width"> {
  width?: DataColumn<T>["width"]
}

export type TimestampColumnHelper<T> = (
  accessorFn: TimestampAccessorFn<T>,
  format: Format,
  col: TimestampColumn<T>
) => DataColumn<T>

export function timestamp<T>(
  accessorFn: TimestampAccessorFn<T>,
  format: Format,
  col: TimestampColumn<T>
): DataColumn<T> {
  const { width, ...restCol } = col
  return data({
    renderCell: (rowData) => {
      const value = accessorFn(rowData)
      if (value === undefined) return "—"
      return Timestamp.format(format, value)
    },
    width: width ?? TableCellWidth.Medium,
    ...restCol,
  })
}
